import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, TextField, Checkbox, ListItemText, MenuItem, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { MainBox } from '@/common/layout/MainBox';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { useEffect, useState } from 'react';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { McoDispTrendChart } from '@/sc/entities/mcoInv/dashboard/fin/McoDispTrendChart';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { McoFinTrendChart } from './McoFinTrendChart';


export const McoFinDashboard = () => {

  const rsrc = useRsrc();
  const { navState, assign } = useNavState();
  const dashboardNavState = navState['mcoInvDashboardState'] ?? {};

  const [isUnits, setIsUnits] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState();

  const [pbms, setPbms] = useState();
  const [selectedPbms, setSelectedPbms] = useState([]);

  const [ctrts, setCtrts] = useState();
  const [selectedCtrts, setSelectedCtrts] = useState([]);

  // const [progTypes, setProgTypes] = useState();
  // const [selectedProgTypes, setSelectedProgTypes] = useState([]);

  const [finTrendIsPaid, setFinTrendIsPaid] = useState(true);
  const [finTrendIsChart, setFinTrendIsChart] = useState(true);

  // const [topCtrtValueType, setCtrtValueType] = useState('inv')

  useEffect(() => {
    rsrc.data('sc', 'MCO_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then(res => {
      setPeriods(res.periods);
      // Restore nav state
      if (dashboardNavState.selectedPeriodId) {
        const period = res.periods.find(p => p.id === dashboardNavState.selectedPeriodId);
        if (period) setSelectedPeriod(period);
      }
      // or set to first period
      else if (res.periods?.length > 0) {
        const selectedPeriod = res.periods[0];
        setSelectedPeriod(selectedPeriod);
      }

      setPbms(res.pbms);
      if (dashboardNavState.selectePbmCodes) {
        const matchedPbms = res.pbms.filter(pbm =>
          dashboardNavState.selectePbmCodes.includes(pbm.code)
        );
        if (matchedPbms.lenght > 0) setSelectedPbms(matchedPbms);
      } else {
        setSelectedPbms(res.pbms);
      }

      setCtrts(res.ctrts);
      // Restore nav state
      if (dashboardNavState.selectedCtrtCodes) {
        const matchedCtrts = ctrts.filter(ctrt =>
          dashboardNavState.selectedCtrtCodes.includes(ctrt.code)
        );
        if (matchedCtrts.length > 0) setSelectedCtrts(matchedCtrts);
      } else {
        setSelectedCtrts(res.ctrts);
      }

      // setProgTypes(res.progTypes);
      // // Restore nav state
      // if (dashboardNavState.selectedProgTypes) {
      //   const matchedProgTypes = res.progTypes.filter(progType =>
      //     dashboardNavState.selectedProgTypes.includes(progType)
      //   );
      //   if (matchedProgTypes.length > 0) setSelectedProgTypes(matchedProgTypes);
      // } else {
      //   setSelectedProgTypes(res.progTypes);
      // }
    });
  }, []);

  const saveNavState = () => {
    const newDashboardNavState = {
      selectedPeriodId: selectedPeriod?.id,
      selectedPbmCodes: selectedPbms?.map(pbm => pbm.code),
      selectedCtrtCodes: selectedCtrts?.map(c => c.code)
    };

    assign('mcoInvDashboardState', newDashboardNavState);
  };

  useEffect(() => {
    saveNavState();
  }, [selectedPeriod, selectedPbms, selectedCtrts]);

  if (!periods || !pbms || !ctrts) return null;

  const trendButtons = <>
    <ToggleButtonGroup exclusive size="small" value={finTrendIsPaid} sx={{ width: 'fit-content' }} onChange={(event, value) => { setFinTrendIsPaid(value) }}>
      <ToggleButton value={true} aria-label="bold">
        Paid
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Dispute
      </ToggleButton>
    </ToggleButtonGroup>
    <ToggleButtonGroup exclusive size="small" value={finTrendIsChart} sx={{ width: 'fit-content' }} onChange={(event, value) => { setFinTrendIsChart(value) }}>
      <ToggleButton value={true} aria-label="bold">
        Chart
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Table
      </ToggleButton>
    </ToggleButtonGroup>
  </>;

  // const topCtrtButtons = <>
  //   <Box>
  //     <ToggleButtonGroup
  //       exclusive
  //       value={topCtrtValueType}
  //       onChange={(event, value) => {
  //         if (value) setCtrtValueType(value);
  //       }}
  //       size="small"
  //       sx={{ width: 'fit-content' }}
  //     >
  //       <ToggleButton value="inv" aria-label="Invoice">
  //         Invoice
  //       </ToggleButton>
  //       <ToggleButton value="disp" aria-label="Dispute">
  //         Dispute
  //       </ToggleButton>
  //       <ToggleButton value="paid" aria-label="Paid">
  //         Paid
  //       </ToggleButton>
  //       <ToggleButton value="due" aria-label="Due">
  //         Due
  //       </ToggleButton>
  //     </ToggleButtonGroup>
  //   </Box>
  // </>;

  if (!periods || !pbms || !ctrts) return null;

  return (
    <MainBox>
      {/* Title */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        mb: 1
      }}>
        <Title icon={fas.faTasks} title="Managed Care Financial Dashboard" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <ToggleButtonGroup
            exclusive
            value={isUnits}
            sx={{ height: 'fit-content' }}
            onChange={(event, value) => { setIsUnits(value) }}>
            <ToggleButton value={false} aria-label="dollars">
              Dollars
            </ToggleButton>
            <ToggleButton value={true} aria-label="units">
              Units
            </ToggleButton>
          </ToggleButtonGroup>

        </Box>
      </Box>
      {/* Filters */}

      <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        {/* Period */}
        <TextField
          fullWidth
          select
          variant="outlined"
          label="Invoice Period"
          value={selectedPeriod?.id || ''}
          onChange={event => {
            const period = periods.find(p => p.id === event.target.value);
            setSelectedPeriod(period);
          }}>
          {periods?.map(period => (
            <MenuItem key={period.id} value={period.id}>
              {period.code}
            </MenuItem>
          ))}
        </TextField>

        {/* PBMs */}
        <TextField fullWidth select
          variant="outlined"
          label="PBMs"
          value={selectedPbms}
          onChange={event => setSelectedPbms(event.target.value)}
          SelectProps={{
            multiple: true,
            renderValue: (selected) => selected.map((p) => p.code).join(', ')
          }}>
          {pbms?.map(pbm => (
            <MenuItem key={pbm.code} value={pbm}>
              <Checkbox checked={selectedPbms?.some((p) => p.code === pbm.code)} />
              <ListItemText primary={pbm.code} />
            </MenuItem>
          ))}
        </TextField>

        {/* Contracts */}
        <TextField fullWidth select
          variant="outlined"
          label="Contracts"
          value={selectedCtrts}
          onChange={event => setSelectedCtrts(event.target.value)}
          SelectProps={{
            multiple: true,
            renderValue: (selected) => selected.map((p) => p.code).join(', ')
          }}>
          {ctrts?.map(ctrt => (
            <MenuItem key={ctrt.code} value={ctrt}>
              <Checkbox checked={selectedCtrts?.some((p) => p.code === ctrt.code)} />
              <ListItemText primary={ctrt.name} />
            </MenuItem>
          ))}
        </TextField>

        {/* Prog Types */}
        {/* <TextField fullWidth select
          variant="outlined"
          label="Program Types"
          value={selectedProgTypes}
          onChange={event => setSelectedProgTypes(event.target.value)}
          SelectProps={{
            multiple: true,
            renderValue: (selected) => selected.map((p) => p).join(', ')
          }}>
          {progTypes?.map(progType => (
            <MenuItem key={progType} value={progType}>
              <Checkbox checked={selectedProgTypes?.some((p) => p === progType)} />
              <ListItemText primary={progType} />
            </MenuItem>
          ))}
        </TextField> */}

      </Box>

      {/* Main Contents */}
      <SpacerLayout>
        <Spacer vertical>
          {/* Row 1 */}
          <Spacer weights={[1, 1]}>

            <DashboardCard title="Month Over Month Trends" sx={{ flex: 1 }} buttons={trendButtons} >
              <McoFinTrendChart
                selectedPeriod={selectedPeriod}
                selectedPbms={selectedPbms}
                selectedCtrts={selectedCtrts}
                isUnits={isUnits}
                isPaid={finTrendIsPaid}
                isChart={finTrendIsChart}
              />
            </DashboardCard>

            {/* <DashboardCard title="Paid vs Disputed Trends" sx={{ flex: 1 }}>
              <McdFinPaidDispTrendChart
                selectedPeriod={selectedPeriod}
                selectedPbms={selectedPbms}
                selectedCtrts={selectedCtrts}
                isUnits={isUnits}
              />
            </DashboardCard> */}

          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[3, 2, 2]}>
            {/* <DashboardCard title="Top Contracts" sx={{ flex: 1 }} buttons={topCtrtButtons}>
              <McdFinTopCtrtGrid
                selectedPeriod={selectedPeriod}
                selectedPbms={selectedPbms}
                isUnits={isUnits}
                topCtrtValueType={topCtrtValueType}
              />
            </DashboardCard> */}

            {/* <DashboardCard title="Dispute Code Breakdown" sx={{ flex: 1 }}>
              <McoDispBreakdownPieChart
                selectedPeriod={selectedPeriod}
                selectedPbms={selectedPbms}
                selectedCtrts={selectedCtrts}
                isUnits={isUnits}
              />
            </DashboardCard> */}

            <DashboardCard title="Dispute Code Trends" sx={{ flex: 1 }}>
              <McoDispTrendChart
                selectedPeriod={selectedPeriod}
                selectedPbms={selectedPbms}
                selectedCtrts={selectedCtrts}
                // selectedProgTypes={selectedProgTypes}
                isUnits={isUnits}
              />
            </DashboardCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </MainBox>
  );
};